export default __webpack_public_path__ + "a11bfe9a6a8a8e7e17657ef9cba8765d.png";